import { render, staticRenderFns } from "./ConfigurationSubmenu.vue?vue&type=template&id=57d1d15f&"
import script from "./ConfigurationSubmenu.vue?vue&type=script&lang=js&"
export * from "./ConfigurationSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationSubmenu.vue?vue&type=style&index=0&id=57d1d15f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports